/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
//standard libraries.
import React from "react";
import { useTranslation } from "react-i18next";
import Grid from "@material-ui/core/Grid";
import styled from "styled-components";
import NavigateBeforeIcon from "@material-ui/icons/NavigateBefore";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";

import { Button } from "../components";

interface PaginationProps {
  offset: number;
  count: number;
  limit: number;
  getPrev: Function;
  getNext: Function;
  [extraProps: string]: any;
}

const ComponentWrapper: React.FC<PaginationProps> = (props: any) => {
  const { offset, count, limit, getPrev, setSize, getNext, ...rest } = props;
  const { t } = useTranslation();
  return (
    <Grid container alignItems="center" wrap="nowrap" spacing={2} {...rest}>
      {offset > 0 && (
        <Grid item>
          <Button color="secondary" size="small" onClick={getPrev}>
            <NavigateBeforeIcon />
          </Button>
        </Grid>
      )}
      <Grid item>
        {t("Table.Pagination.OfTotoalCount", {
          from: offset + 1,
          to: limit + offset > count ? count : limit + offset,
          total: count,
        })}
      </Grid>
      {limit + offset < count && (
        <Grid item>
          <Button color="secondary" size="small" onClick={getNext}>
            <NavigateNextIcon />
          </Button>
        </Grid>
      )}
    </Grid>
  );
};

const Pagination = styled(ComponentWrapper)`
  ${({ theme }) => `
    min-height: 60px;
    display: flex;
    justify-content: flex-end;

    .MuiButton-root{
      padding: ${theme.spacing(1)}px;
      min-width: unset;
    }
  `}
`;

export default Pagination;
